<template>
  <div id="app">
  	<input class="input" type="number" name="" v-model.number="radius" placeholder="Radius (km)" />
  	<button @click="getNearbyPonds">Search</button>
  	
  	<div v-for="key in fishPondKeys" class="fishpond">
  	    <h2 class="fishpond-name">{{ fishponds[key].name }}</h2>
  	    <p class="fishpond-count">Number of fish: {{ fishponds[key].fish }}</p>
  	    <p class="fishpond-species">Fish species:</p>
  	    <ul class="fishpond-fishList">
  	        <li  class="fishpond-fish" v-for="fish in fishponds[key].species">{{ fish}}</li>
  	    </ul>
  	    <p class="fishpond-ph">pH Level: {{ fishponds[key].phLevel }}</p>
  	</div>
  	
  </div>
</template>

<script>
// 8 12 20 40

import firebase from 'firebase';
import geofire from 'geofire';

// Firebase configuration settings
  const config = {
     apiKey: "AIzaSyDcQwXbuECySxaOo7_c_wKhpHK_YU362hA",
    databaseURL: "https://vuejs-eb7e3.firebaseio.com"
  };

// initialise firebase App
const firebaseApp = firebase.initializeApp(config);

// Setup the link to our geofire database that will act as our fishpond location database
// the string passed to the child method is the name of the database where geofire will store and access location data

let geoFireRef = firebase.database().ref().child('fishponds');
let geoFireApp = new geofire(geoFireRef);

export default {
  name: 'app',
  data () {
    return {
          fishponds:{
            pond1:{
                name:"Rainbow Pond",
                fish:12,
                species:["Angel",'Raindow','trout'],
                phLevel:5
            },
             pond2:{
                name:"Unicorn Pond",
                fish:42,
                species:['Catfish','Haddock'],
                phLevel:7
            },
             pond3:{
                name:"Raindrop Pond",
                fish:8,
                species:['trout', 'goldfish','Flathead'],
                phLevel:8
            },
             pond4:{
                name:"Butterfly Pond",
                fish:135,
                species:['Guppy','trout'],
                phLevel:4.3
            },
            
        },
        geofireQuery:null, // Query object
        centre:[47.493959,-111.282791],  // search center
        radius:0,  // search radius
        fishPondKeys:[] // fishponds within radius
    }
  },
  methods:{
   getNearbyPonds(){
       
         if (this.geofireQuery != null) {
    
          this.geofireQuery.updateCriteria({
            center: this.centre,
            radius: this.radius
          });
    
        } else {
    
          this.geofireQuery = geoFireApp.query({
                center: this.centre,
                radius: this.radius
            });
    
           this.geofireQuery.on("key_entered", (key, location, distance)=> {
            this.fishPondKeys.push(key);
          });
    
           this.geofireQuery.on("key_exited", (key, location, distance) => {
            let removeIndex = this.fishPondKeys.findIndex(x => x == key);
           
            this.fishPondKeys.splice(removeIndex,1);
          });
       
        }
    }
  }
}
</script>

<style>

#app{
    width: 800px;
    margin: 0 auto;
}

html { overflow-y: auto; 
    background-color: #e1e1e1;
    height:100%;
}

button{
    display:block;
}

.fishpond{
    width: calc(400px - 2em);
    padding: 1em;
    background: white;
    border-radius: 25px;
    display: inline-block;
    margin: 1em;
}

.fishpond-name{
    text-align:center;
    font-weight:bold;
}

body{
    color:black;
}

.main-container{
 padding:0 2em;   
}

.input:focus, .input.is-focused, .input:active, .input.is-active, .textarea:focus, .textarea.is-focused, .textarea:active, .textarea.is-active {
    border-color: #00d1b2;
    box-shadow:none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue